export type IconProps = React.HTMLAttributes<SVGElement>;

export const ThumbaIcon = (props: IconProps) => (
  <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g id="logo">
      <g id="Group 145">
        <path
          id="Vector"
          d="M23.4059 9.34026L16.7073 16.0504L20.7717 20.1076L27.4702 13.3975L23.4059 9.34026Z"
          fill="currentColor"
        />
        <path
          id="Vector_2"
          d="M28.5833 14.5143L21.8848 21.2245L25.9492 25.2817L32.6477 18.5716L28.5833 14.5143Z"
          fill="currentColor"
        />
        <path
          id="Vector_3"
          d="M38.7535 14.6849L27.0649 26.3937L31.1293 30.4509L42.8179 18.7421L38.7535 14.6849Z"
          fill="currentColor"
        />
        <path
          id="Vector_4"
          d="M43.9359 19.8588L32.2473 31.5676L36.3117 35.6249L48.0003 23.9161L43.9359 19.8588Z"
          fill="currentColor"
        />
        <path
          id="Union"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.9614 15.5485L16.4506 13.0566H16.4446L12.382 9L9.89671 11.491L9.89629 11.4906L5.83899 15.5549L5.84059 15.5565L2.07236 19.3334C1.98835 19.4115 1.97635 19.5375 2.04236 19.6335L5.08484 24.0381C5.17485 24.1581 5.34888 24.1701 5.4509 24.0681L9.90273 19.6115L31.1342 40.8056L35.1915 36.7413L13.9614 15.5485Z"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
);
